import { render, staticRenderFns } from "./LevelsView.vue?vue&type=template&id=748b4fbf&scoped=true&"
import script from "./LevelsView.vue?vue&type=script&lang=ts&"
export * from "./LevelsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b4fbf",
  null
  
)

export default component.exports